import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../store/store";

const baseUrl =process.env.REACT_APP_base_URL;

const updateRequirementBoardNameApi = createApi({
    reducerPath: 'updateRequirementBoardNameApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateRequirementBoardName: builder.mutation({
            query: ({ boardId, boardName }) => ({
                url: `requirement_boards/${boardId}`,
                method: 'PUT',
                body: { board_name: boardName },
            }),
            transformResponse: (response) => {
            return response
            },
        }),
    }),
});

export const { useUpdateRequirementBoardNameMutation } = updateRequirementBoardNameApi;
export default updateRequirementBoardNameApi;
